import React from "react";
import { Alert } from "@mui/material";

export default function ReviewServerWarnings({ warnings = [] }) {
  if (!warnings.length) return null;
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <strong>Heads up:</strong>
      <ul style={{ margin: "6px 0 0 18px" }}>
        {warnings.map((w, i) => (
          <li key={i}>{w.message || String(w)}</li>
        ))}
      </ul>
    </Alert>
  );
}
